// Permission helper — mirrors backend access_control.py vocabulary.
// Levels: none < view < task_only < edit

const RANK = { none: 0, view: 1, task_only: 2, edit: 3 };

export function hasLevel(user, tracker, minLevel = 'view') {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const eff = user.effective_permissions || {};
  const level = eff[tracker] || 'none';
  return (RANK[level] || 0) >= (RANK[minLevel] || 0);
}

export function getLevel(user, tracker) {
  if (!user) return 'none';
  if (user.role === 'admin') return 'edit';
  const eff = user.effective_permissions || {};
  return eff[tracker] || 'none';
}

// Board-specific helpers
export function canSeeBoard(user, tracker) { return hasLevel(user, tracker, 'view'); }
export function canAllocateTasks(user, tracker) { return hasLevel(user, tracker, 'task_only'); }
export function canExecuteBoard(user, tracker) { return hasLevel(user, tracker, 'edit'); }
